import _regenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/crm-admin-uat/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import myCustomers from '@/api/admissionCounseling/myCustomers';
import rightCom from './rightCom/index.vue';
import InfoCom from './leftTopCom/infoCom.vue';
import BtnsCom from './leftTopCom/btnsCom.vue';
import LogCom from './logCom/index.vue';
import MsgInviteCom from './leftTopCom/msgInviteCom.vue';
import PhoneCallCom from './leftTopCom/phoneCallCom.vue';
import { getAiErrorReason } from '@/api/admissionCounseling/customerDrawerCom';
export default {
  name: 'CustomerDrawer',
  components: {
    rightCom: rightCom,
    InfoCom: InfoCom,
    BtnsCom: BtnsCom,
    LogCom: LogCom,
    MsgInviteCom: MsgInviteCom,
    PhoneCallCom: PhoneCallCom
  },
  props: {
    // 客户id
    cId: {
      type: Number,
      default: 0
    },
    // 是否需要遮罩层
    drawerModal: {
      type: Boolean,
      default: true
    },
    // 是否用于我的客户，需要获取访问统计数据
    isCustomerList: {
      type: Boolean,
      default: false
    },
    // 是否是客户管理（流量）菜单下打开客户滑窗
    isFlowCustomerManage: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      drawerForm: {
        name: '',
        phone1: '',
        wxchat1: '',
        phone2: '',
        wxchat2: '',
        qq: '',
        projectId: '',
        provinceId: '',
        city: '',
        county: '',
        gender: 2,
        eduBackground: '',
        lastCommunicationLog: ''
      },
      // 抽屉表单
      drawerEvalForm: {
        // 咨询评价
        intentionLevel: '',
        label: []
      },
      labelList: [],
      // 用户标签
      aiErrorReasonOpt: [],
      crmLabel: [] // 用户标签，新增标签（比如ai评分、续报标签）
    };
  },
  computed: {
    isOwner: function isOwner() {
      var $store = this.$store,
        drawerForm = this.drawerForm;
      return $store.state.user.user.id === drawerForm.ownerId;
    },
    rightComData: function rightComData() {
      var drawerEvalForm = this.drawerEvalForm,
        drawerForm = this.drawerForm;
      return {
        evaluation: drawerEvalForm.evaluation,
        intentionLevel: drawerEvalForm.intentionLevel,
        invalidTypeId: drawerEvalForm.invalidTypeId,
        label: drawerEvalForm.label,
        aiLabel: drawerEvalForm.aiLabel,
        aiAdvice: drawerEvalForm.aiAdvice,
        registered: drawerForm.registered // 是否已报名，用于判断已报名客户不可评价为静默
      };
    },
    clockInfo: function clockInfo() {
      var _this$drawerForm = this.drawerForm,
        name = _this$drawerForm.name,
        contactPhone = _this$drawerForm.contactPhone,
        contactWechat = _this$drawerForm.contactWechat;
      return {
        name: name,
        contactPhone: contactPhone,
        contactWechat: contactWechat
      };
    },
    canEdit: function canEdit() {
      var isOwner = this.isOwner,
        isFlowCustomerManage = this.isFlowCustomerManage,
        drawerForm = this.drawerForm;
      return {
        isOwner: isOwner,
        isFlowCustomerManage: isFlowCustomerManage,
        editable: drawerForm.editable
      };
    }
  },
  watch: {
    // 监听客户id变化，就调接口。但是有一种情况，手动分配后，再次打开，这个名片不会调接口，所以就从关闭抽屉的时候改变客户id
    cId: function cId(newVal) {
      if (newVal) {
        var init = this.init;
        init();
      }
    }
  },
  mounted: function mounted() {
    this.getAiErrorReasonOpt();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var getCustomerInfo, cId, getEvaluationsList;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              getCustomerInfo = _this.getCustomerInfo, cId = _this.cId, getEvaluationsList = _this.getEvaluationsList;
              _context.n = 1;
              return getCustomerInfo(cId);
            case 1:
              _context.n = 2;
              return getEvaluationsList(cId);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 关闭客户滑窗前的回调
    handleCloseDrawer: function handleCloseDrawer() {
      this.closeDrawer();
    },
    // 关闭客户滑窗
    closeDrawer: function closeDrawer() {
      this.$emit('closeDrawer');
    },
    // 查询单个名片
    getCustomerInfo: function getCustomerInfo(id) {
      var _this2 = this;
      myCustomers.customersInfo(id).then(function (res) {
        _this2.drawerForm = res;
      });
    },
    // 查询评价
    getEvaluationsList: function getEvaluationsList(id) {
      var _this3 = this;
      myCustomers.customersEvaluations(id).then(function (res) {
        if (res) {
          var evaluation = res.evaluation,
            intentionLevel = res.intentionLevel,
            invalidType = res.invalidType,
            aiLabel = res.aiLabel,
            aiAdvice = res.aiAdvice;
          // 评价表单
          _this3.drawerEvalForm = {
            evaluation: evaluation,
            intentionLevel: evaluation === 3 ? undefined : intentionLevel,
            invalidTypeId: invalidType ? invalidType.id : undefined,
            aiLabel: aiLabel,
            aiAdvice: aiAdvice
          };
          if (res.evaluation === 1 && Number(res.intentionLevel) === 7) {
            // evaluation:1 静默；intentionLevel：7 无意向度
            _this3.drawerEvalForm.intentionLevel = -1;
            _this3.drawerEvalForm.invalidTypeId = Number(res.invalidType.id);
          } else if (res.evaluation === 1 && Number(res.intentionLevel) !== 7) {
            //  咨询评价为静默
            _this3.drawerEvalForm.intentionLevel = 6;
            _this3.drawerEvalForm.invalidTypeId = Number(res.invalidType.id);
          }
          var label = res.label,
            crmLabel = res.crmLabel;
          _this3.labelList = label;
          _this3.crmLabel = crmLabel;
          if (label) {
            _this3.drawerEvalForm.label = label.map(function (item) {
              item.id;
            });
          }
        } else {
          // 没有返回值，置空所有
          _this3.drawerEvalForm = {};
        }
      });
    },
    handleRefresh: function handleRefresh() {
      var init = this.init;
      init();
    },
    getAiErrorReasonOpt: function getAiErrorReasonOpt() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getAiErrorReason();
            case 1:
              res = _context2.v;
              _this4.aiErrorReasonOpt = res;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getLabel: function getLabel() {
      var cId = this.cId,
        getEvaluationsList = this.getEvaluationsList;
      getEvaluationsList(cId);
    }
  }
};